import React from "react";
import { useState } from "react";
import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import axios from "axios";

import styles from "./StripeInput.module.css";

import { siteIP } from "../util/backendUtilities";

import { ThreeDots } from "react-loading-icons";

import { ButtonOrange } from "./Button";
import { CiHeart } from "react-icons/ci";
import ReCaptcha, {
  useVerifyRecaptcha,
} from "../components/grecaptcha/ReCaptcha";

import {
  sendDonationNotification,
  sendDonationConfirmation,
} from "./emailJS/EmailJS";

const CARD_OPTIONS = {
  iconStyle: "solid",
  disableLink: true,
  style: {
    base: {
      backgroundColor: "#f3f3f5",
      iconColor: "#fab78a",
      color: "#000",
    },
    invalid: {
      iconColor: "#ff5858",
      color: "#ffcbcb",
    },
  },
};

const StripePaymentForm = ({ formData, amount }) => {
  const stripe = useStripe();
  const elements = useElements();

  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const recaptchaIsVerified = useVerifyRecaptcha(recaptchaToken);

  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");

  const submitHandler = async (e) => {
    e.preventDefault();

    if (recaptchaIsVerified) {
      setIsLoading(true);
      const { error, paymentMethod } = await stripe.createPaymentMethod({
        type: "card",
        card: elements.getElement(CardElement),
      });

      if (!error) {
        try {
          const { id } = paymentMethod;
          const response = await axios.post(`${siteIP}/payment`, {
            amount: amount,
            description: `${formData.firstName} ${formData.lastName} - ${formData.email}`,
            id,
          });
          if (response.data.success) {
            setIsLoading(false);
            //*PAYMENT SUCCEEDED
            console.log(response.data.message);
            setMessage(response.data.message);
            const receiptEmailData = { ...formData, amount: amount };
            await sendDonationNotification(receiptEmailData);

            const confirmResponse = await sendDonationConfirmation(
              receiptEmailData
            );
            if (confirmResponse) {
              console.log(confirmResponse);
              setMessage((prev) => (prev += ` ${confirmResponse}`));
            }
          } else {
            //! PAYMENT NOT SUCCESSFUL
            setIsLoading(false);
            console.log(response.data.message);
            setMessage(response.data.message);
          }
        } catch (error) {
          //TODO: Handle error from the server call.
        }
      }
    } else {
      alert("Please complete the reCAPTCHA checkbox");
    }
  };

  return (
    <form onSubmit={submitHandler}>
      <fieldset style={{ border: "none" }} className={styles.stripeInput}>
        <CardElement options={CARD_OPTIONS} />
      </fieldset>
      <br />
      <br />
      {/* Submit Button */}
      <div className={styles.submitBtn}>
        <ButtonOrange>
          Complete Donation{" "}
          {isLoading ? <ThreeDots width="15%" /> : <CiHeart />}
        </ButtonOrange>
      </div>
      <p style={{ marginTop: "20px", marginBottom: "40px", color: "black" }}>
        {message}
      </p>
      <div className={styles.recaptcha}>
        <ReCaptcha setToken={setRecaptchaToken} />
      </div>
    </form>
  );
};

export default StripePaymentForm;
